import jQuery from "jquery";
export default jQuery;
window.jQuery = window.$ = jQuery;
